
import React from "react";
import MainLayout from "../../components/layout/MainLayout";
import Projects from "../../components/admin/Projects";

const AdminProjects: React.FC = () => {
  return (
    <MainLayout>
      <Projects />
    </MainLayout>
  );
};

export default AdminProjects;
